/* template */
<template><div class="mpx-root-view"><es-drawer-bottom :navbarStyle="(navbarStyle)" :show="(showDrawer)" @close="close" class="main"><Content :type="(type)"/><div class="buttons"><mpx-view @tap="confirm" class="btn">确认取消</mpx-view><mpx-view @tap="close" class="btn">再抢抢看</mpx-view></div></es-drawer-bottom><es-popup @close="close" :show="(showPopup)"><div class="popup-container"><Content :type="(type)"/></div></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m57106d58"}'>
  .popup-container
    width 335px
    height 306px
    background #ffffff
    border-radius 16px
  .main
    /deep/ .drawer-container
      height 449px
      overflow auto
      .drawer-main
        padding 0
    .buttons
      @extend .flex-center
      justify-content space-between
      line-height 1
      font-weight normal
      font-family PingFangSC-Regular
      font-size 14px
      color #333333
      padding 0 20px
      .btn
        flex 1
        @extend .flex-center
        justify-content center
        border-radius 8px
        border 1px solid #CCCCCC
        padding 14px 0
        &:last-child
          border 1px solid #FF6400
          background #FF6400
          color #fff
          margin-left 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m57106d58"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex57106d58%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex57106d58%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m57106d58"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index57106d58/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'Content':getComponent(require("./content.mpx?isComponent&outputPath=components%2Fcontent6dda46bb%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
